// extracted by mini-css-extract-plugin
export default {"timeIndicator":"hQeXpIogyO"};